import disabledEmphasis from '../../../../text/disabled-emphasis';

const light = (params) => disabledEmphasis(params);

export default light;
